import styled from 'styled-components/macro';
import close from '../../assets/icons/x.svg';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  margin: 0 !important;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  opacity: 1;
`;

export const Body = styled.div`
  background-color: #f8f9fa;
  width: 45%;
  height: 100vh;
  overflow-y: auto;
  opacity: 1;
  padding: 24px;
  box-sizing: border-box;

  & > div {
    margin-bottom: 24px;

    &:last-child {
      margin: 0;
    }
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    height: 20px;
    background: #2675b6ff;
    border-radius: 5px;
  }
`;

export const Circle = styled.div`
  position: absolute;
  top: 50vh;
  left: 55vw;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f8f9fa;
  cursor: pointer;
  z-index: 99999;
`;

export const CloseIcon = styled.img.attrs({
  src: close,
})`
  width: 16px;
  height: 16px;
`;
